import { useState, useCallback, useRef } from "react";

import PerfectScrollbar from "react-perfect-scrollbar";
// @material-ui/core components
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";
// @material-ui/icons components
// core components
import UploadFile from "components/Dropzone/UploadFile";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";

const validator = (file) => {
  if (!file.name.includes(".csv")) {
    return {
      code: "invalid-extension",
      message: "A extensão do arquivo deve ser .csv",
    };
  }
};

const getFilesErrors = (files) => {
  const errorsList = files.map((file) => `${file.name}: ${file.error}`);

  return errorsList.map((msg, index) => {
    return (
      <div key={index} style={{ marginBottom: "0.5rem" }}>
        &#8226; <Typography variant="caption">{msg}</Typography>
      </div>
    );
  });
};

function DialogUploadRelatorioApuracao({ open, onClose }) {
  const [importando, setImportando] = useState(false);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const snackbar = useSnackbar();
  const contentRef = useRef(null);

  const handleClose = useCallback(() => {
    setFilesToUpload([]);
    onClose();
  }, [onClose]);

  const importar = useCallback(() => {
    setImportando(true);

    const uploadPromises = filesToUpload.map((file) => {
      return new Promise((resolve) => {
        UtilsFncs.FileToB64(file)
          .then((base64Csv) => {
            let encodedBase64 = base64Csv
              ?.toString()
              ?.replace(/^data:(.*,)?/, "");

            if (encodedBase64.length % 4 > 0) {
              encodedBase64 += "="?.repeat(4 - (encodedBase64.length % 4));
            }

            Api.post(
              "set-fvk-infinite-shelf-csv",
              "sellinorder",
              { base64Csv: encodedBase64 },
              true
            )
              .then((res) => {
                if (res.Success) {
                  resolve({
                    name: file.name,
                    success: true,
                  });
                }
              })
              .catch((error) => {
                resolve({
                  name: file.name,
                  error,
                });              });
          })
          .catch((error) => {
            console.log("Erro ao converter file para b64: " + error);
            resolve({
              name: file.name,
              error: "Não foi possível utilizar o arquivo formatado",
            });
          });
      });
    });

    Promise.all(uploadPromises).then((returns) => {
      const filesWithError = returns.filter((file) => Boolean(file.error));

      if (
        filesWithError.length >= 1 &&
        filesWithError.length < returns.length
      ) {
        snackbar.showMessage(
          <div>
            Alguns relatórios retornaram erro, os demais foram bem sucedidos:
            <br />
            <br />
            {getFilesErrors(filesWithError)}
          </div>,
          {
            severity: "warning",
            autoHideDuration: 10000,
          }
        );
      } else if (filesWithError.length === 1) {
        snackbar.showMessage(filesWithError[0].error, {
          severity: "error",
        });
      } else if (filesWithError.length > 1) {
        snackbar.showMessage(
          <div>
            Os seguintes relatórios retornaram erro:
            <br />
            <br />
            {getFilesErrors(filesWithError)}
          </div>,
          {
            severity: "error",
            autoHideDuration: 10000,
          }
        );
      } else {
        snackbar.showMessage("Importação realizada com sucesso!", {
          severity: "success",
        });
        handleClose();
      }

      setImportando(false);
    });
  }, [filesToUpload, snackbar, handleClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span>
          <Typography variant="h3" component="h3">
            Importar relatório de apuração
          </Typography>
        </span>
      </DialogTitle>
      <PerfectScrollbar containerRef={() => contentRef}>
        <DialogContent
          ref={contentRef}
          style={{ overflowY: "hidden", padding: "0 1.5rem" }}
        >
          <Typography id="alert-dialog-description" variant="h4">
            Siga as instruções para a importação do relatório:
          </Typography>
          <Typography variant="caption">
            1) Os cabeçalhos IdPedido, IdMarca, IdProduto, EanProduto,
            IdPedidoFvk, DtHoraImportacao e IdUsuarioImportacao são obrigatórios
            e devem ser escritos exatamente desta forma.
          </Typography>
          <br />
          <Typography variant="caption">
            2) As colunas IdPedido, IdMarca, IdProduto, EanProduto e IdPedidoFvk
            devem vir preenchidas.
          </Typography>
          <br />
          <Typography variant="caption">
            3) A extensão do arquivo deve ser .csv.
          </Typography>
          <br />
          <br />
          <UploadFile
            multiple
            accept=".csv"
            validator={validator}
            onChangeFiles={setFilesToUpload}
            disabled={importando}
          />
          {importando && (
            <>
              <br />
              <div>
                <span>importando relatório...</span>
                <LinearProgress />
              </div>
            </>
          )}
        </DialogContent>
      </PerfectScrollbar>
      <DialogActions>
        <Button component={Box} onClick={handleClose} disabled={importando}>
          Cancelar
        </Button>
        <Button
          component={Box}
          variant="contained"
          onClick={importar}
          disabled={importando}
          color="default"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogUploadRelatorioApuracao;
